<template>
  <div class="video">
    <!-- video element -->
    <div :class="[videoStarted ? 'block' : 'hidden']">
      <video
        controls
        :src="video"
        ref="videoEl"
        class="video-videoEl"
        @pause="$emit('pauseVideo', $event.target.currentTime, $event.target.duration)"
        @ended="endVideo"
      ></video>
    </div>

    <!-- video thumbnail play -->
    <div
      v-if="!completed && !videoStarted"
      class="video-thumbnail"
      :style="{ backgroundImage: `url(${thumbnail})` }"
    >
      <button class="video-play" @click="startVideo">
        <span />
      </button>
    </div>

    <!-- video thumbnail replay -->
    <div
      v-if="completed && !videoStarted"
      class="video-thumbnail"
      :style="{ backgroundImage: `url(${thumbnail})` }"
    >
      <div class="video-thumbnail-content">
        <span class="text-4xl font-semibold text-white">{{ $t('preTraining.video.heading') }}</span>
        <span class="mb-3 text-white" v-if="isIntro && !isIntroPassed">
          {{ $t('preTraining.video.subheadingStart') }}
        </span>
        <span class="mb-3 text-white" v-else-if="isIntro && isIntroPassed">
          {{ $t('preTraining.video.subheadingContinue') }}
        </span>
        <span class="mb-3 text-white" v-else-if="isLast">
          {{ $t('preTraining.video.subheadingSchedule') }}
        </span>
        <span class="mb-3 text-white" v-else>
          {{ $t('preTraining.video.subheadingQuiz') }}
        </span>
        <button class="video-replay" @click="resetVideo">
          <VSvgIcon name="repeat" class="mr-1" />
          {{ $t('preTraining.video.replayBtn') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import VSvgIcon from '@/components/base/VSvgIcon';

export default {
  name: 'Video',
  components: { VSvgIcon },
  props: {
    thumbnail: String,
    video: String,
    time: Number,
    completed: {
      type: Boolean,
      default: false,
    },
    currentTime: {
      type: String,
      required: false,
    },
    isIntro: {
      type: Boolean,
      required: false,
      default: false,
    },
    isIntroPassed: {
      type: Boolean,
      required: false,
      default: false,
    },
    isLast: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      videoStarted: false,
    };
  },
  methods: {
    startVideo() {
      this.videoStarted = true;
      this.$refs.videoEl.play();
    },
    resetVideo() {
      this.$emit('resetVideo');
      this.startVideo();
    },
    endVideo(event) {
      this.$emit('endVideo', event.target.currentTime);
      this.videoStarted = false;
    },
  },
  mounted() {
    // update currnet video's current time if provided in the props
    const target = this.$refs.videoEl;
    this.currentTime && (target.currentTime = this.currentTime);
    // check for intro video's completion
    target.onloadedmetadata = () => {
      const currentTime = target.currentTime;
      const duration = target.duration;
      this.$emit('checkCompletion', currentTime, duration);
    };
  },
};
</script>
